<template>
  <div>
    <div v-if="postType === 'normal'">
      <div class="p-postBasicEditor__eyecatch">
        <v-img :src="eyecatchableSrc" />
      </div>
      <div>
        <p class="mt-3" style="font-size: 0.7rem">
          出典リンク
          {{ eyecatchSourceUrl }}
        </p>
      </div>
    </div>
    <div v-else-if="postType === 'product'">
      <div class="p-postBasicEditor__eyecatch text-left">
        <ProductImageSlider
          v-if="product.productImages"
          :product-images="product.productImages.map((image) => image.file.url)"
        />
        <p class="mt-5">{{ product.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductUtils from '@/mixins/product_utils'
import ProductImageSlider from '../../commons/ProductImageSlider'

export default {
  components: { ProductImageSlider },
  mixins: [ProductUtils],
  props: {
    postType: {
      type: String,
      required: true
    },
    eyecatchableSrc: {
      type: String,
      required: true
    },
    eyecatchSourceUrl: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="sass">
.p-postBasicEditor
  &__eyecatch
    background-color: #efefef
    width: 240px
    height: 160px
    position: relative
    margin: 0 auto
</style>
